import { Injectable } from '@angular/core'
import { FailureModeDisplayMode } from '../enums/failure-mode-display-mode.enum';

@Injectable({ providedIn: 'root' })
export class TotalsService {
  private _displayMode: FailureModeDisplayMode = FailureModeDisplayMode.Total;

  get displayMode(): FailureModeDisplayMode {
    return this._displayMode;
  }

  set displayMode(value: FailureModeDisplayMode) {
    this._displayMode = value;
  }
}